

function initializeInfluencerScrolling( scrollableitem, scrollablearrowparent ) 
{
  
    if ( scrollableitem ) 
    {
        var scrollRightButton   = scrollablearrowparent.querySelector( ".scrollright" );
        var scrollLeftButton    = scrollablearrowparent.querySelector( ".scrollleft" );
        
         
        updateArrowsVisibility( scrollableitem, scrollRightButton, scrollLeftButton );
        scrollRightButton.addEventListener( "click", function () 
        {
            var scrollableItemWidth = document.querySelector( ".lightning-aisle_article_item" ).clientWidth + 20;
            scrollableitem.scrollLeft += scrollableItemWidth;
            updateArrowsVisibility( scrollableitem, scrollRightButton, scrollLeftButton );
        } );

        scrollLeftButton.addEventListener( "click", function () 
        {
            var scrollableItemWidth = document.querySelector( ".lightning-aisle_article_item" ).clientWidth + 20;
            scrollableitem.scrollLeft -= scrollableItemWidth;
            updateArrowsVisibility( scrollableitem, scrollRightButton, scrollLeftButton );
        } );
        
        scrollableitem.addEventListener( "scroll", function() 
        {
            updateArrowsVisibility( scrollableitem, scrollRightButton, scrollLeftButton );
        } );
    }
  }


window.addEventListener( "DOMContentLoaded", function(e)
{
    var scrollableitem  = document.querySelector( '.lightning-aisle_article_list' );     
    var scrollablearrowparent  = document.querySelector( '.lightning-influencer-arrows' );     
    initializeInfluencerScrolling( scrollableitem, scrollablearrowparent );
});